module.exports = __webpack_public_path__ + "static/media/desktop-smartphone-screenshot-player-icon.d2637623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/desktop-smartphone-screenshot-player-icon.png
// module id = 1820
// module chunks = 0